module.exports = __webpack_public_path__ + "img/0Q3B1666_L_Foamcore_MockedUp.92299574.jpg";